"use client";

import React from "react";
import { BsFillExclamationCircleFill } from "react-icons/bs";

import Button, { ButtonStyle } from "components/Button";
import Modal from "components/Modal";
import { ModalStore } from "store/modalStore";

export const ErrorModal = ({ data, closeModal }: { data: ModalStore; closeModal: () => void }) => {
  const closeModalWithAction = () => {
    closeModal();
    data?.error?.onClose?.();
  };
  if (!data.error) return null;
  return (
    <Modal onClose={closeModalWithAction} isOpen={data.error.modalState === "open"}>
      <div className="relative flex h-[250px] w-[400px] flex-col items-center pb-5">
        <div className="relative flex h-[98px] w-full flex-col items-center justify-center overflow-hidden rounded-t-lg bg-attention px-8 text-center text-white">
          <div className="item-center flex items-center justify-center">
            <BsFillExclamationCircleFill className="fill-white text-[20px]" />
            <p className="ml-2 text-20px">{data.error.errorMessage}</p>
          </div>
        </div>
        <div className="flex h-[84px] flex-col items-center justify-center text-center">
          <p className="text-16px">{data.error.subMessage}</p>
          {data.error.attentionMessage && (
            <p className="flex items-center text-14px text-attention">
              <span className="relative pb-[2px] pr-[2px]">※</span>
              {data.error.attentionMessage}
            </p>
          )}
        </div>
        <div className="relative bottom-0 flex justify-center gap-4">
          {data.error.buttonText && (
            <div className="w-[160px]">
              <Button text={data.error.buttonText} onClick={closeModalWithAction} style={ButtonStyle.OUTLINE} />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};
